<template>
  <v-layout
    row
    justify-center>
    <v-dialog
      v-model="value"
      persistent
      content
      content-class="centered-dialog">
      <v-container fill-height >
        <v-layout
          column
          justify-center
          align-center>
          <v-progress-circular
            :size="70"
            :width="7"
            :color='progressColor'
            indeterminate/>
          <h1 ref="message" class='message' v-if="currentMessage != null">{{ currentMessage }}</h1>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-layout>
</template>

<script>



export default {
  name: 'Loader',
  props: {
    value: { type: Boolean, default: false },
    message: { type: String, default: null },
    nextMessage: {type: Boolean, default: false},
    progressColor: { type: String, default: 'black' }
  },
  data: function () {
    return {
      currentMessage: null
    }
  },
  methods: {
   animateCSS: function (animationName, callback) {
    // const node = document.getElementById(element)
    this.$refs.message.classList.add('animated', animationName)

    function handleAnimationEnd() {
      this.$refs.message.classList.remove('animated', animationName)
      this.$refs.message.removeEventListener('animationend', handleAnimationEnd)

      if (typeof callback === 'function') callback()
    }

    this.$refs.message.addEventListener('animationend', handleAnimationEnd)
  }
  },
  watch: {
    nextMessage : {
      immediate: true, 
      deep: true,
      handler(newVal, oldVal) {
        function handleAfterExit() {
          self.$refs.message.classList.remove('animated', exitAnimation)
          self.$refs.message.removeEventListener('animationend', handleAfterExit)

          self.currentMessage = self.message
          self.$refs.message.classList.add('animated', enterAnimation)
          self.$refs.message.addEventListener('animationend', handleAfterEntrance)
        }

        function handleAfterEntrance() {
          self.$refs.message.classList.remove('animated', enterAnimation)
          self.$refs.message.removeEventListener('animationend', handleAfterEntrance)
        }

        // console.log('next message in loader is:', newVal)
        let enterAnimation = "flipInX"
        let exitAnimation = "flipOutX"
        let self = this
        if(newVal && newVal != oldVal) {
          if(this.$refs && this.$refs.message) {
            this.$refs.message.classList.add('animated', exitAnimation)
            this.$refs.message.addEventListener('animationend', handleAfterExit)
          } else {
            this.currentMessage = this.message
          }

        }
      }
    }
  }

}
</script>

<style >
  .dialog.centered-dialog,
  .v-dialog.centered-dialog
 {
    /* background: #282c2dad; */
    box-shadow: none;
    border-radius: 6px;
    width: 100vw;
    color: whitesmoke;
    overflow: hidden;
    /* width: 100vw;
    height: 100vh;
    
    background-color: #000000; */
  }
</style>
